import { useSupportMode } from '@/contexts/SupportModeContext';
import { cn } from '@/util/cn';

export const Footer = () => {
  const { isSupportMode } = useSupportMode();
  return (
    <footer
      className={cn(
        'page-footer w-full',
        isSupportMode ? 'support-mode-footer' : 'bg-primary'
      )}
      data-support-mode={isSupportMode ? 'true' : undefined}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center px-5 py-4 text-white">
          <a
            className="link text-white transition-colors hover:text-gray-200"
            href="https://b1link.com/Home/TermsAndConditions"
          >
            Terms & Conditions
          </a>
        </div>
        <div className="grid-content flex items-center justify-center">
          <div className="div flex items-center text-white">
            <div className="w-fit">B1LINK &reg;</div>
            <div className="mx-2.5 h-4 w-0.5 border-r-2 border-white" />
            <div className="w-fit">All Rights Reserved {new Date().getFullYear()}</div>
          </div>
        </div>
        <span className="pr-5 text-white">
          {import.meta.env.VITE_DEPLOYMENT_VERSION ?? 'v0000-00-00-00-00'}
        </span>
      </div>
    </footer>
  );
};
